/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.gauge {
  position: relative;

  width: var(--gauge-size);
  height: var(--gauge-size);
  border-radius: calc(var(--gauge-size) / 2);
  line-height: var(--gauge-size);

  background: var(--secondary-background-color);
  color: var(--neutral-color);

  font-family: var(--monospace-font-family);
  font-size: var(--gauge-number-font-size);
  font-weight: var(--medium-font-weight);
  text-align: center;
}

.gauge-arc {
  position: absolute;
  width: var(--gauge-size);
  height: var(--gauge-size);
}

.gauge-arc__arc {
  fill: none;
  stroke: var(--neutral-color);
  stroke-linecap: round;
  stroke-width: var(--gauge-stroke-width);

  transition: stroke-dasharray 0.5s;
}

.gauge-arc__indicator {
  --indicator-width: 3px;
  --indicator-height: 12px;

  position: absolute;
  left: calc(50% - var(--indicator-width) / 2);
  top: calc(var(--indicator-height) / -4);

  width: var(--indicator-width);
  height: var(--indicator-height);
  border-radius: 25%;

  background: var(--neutral-color);
}

.gauge-arc__indicator-wrapper,
.gauge-arc__delta-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  transform-origin: center;

  transition: transform 0.5s;
}

.gauge--improvement .gauge-arc__indicator {
  background: var(--improvement-color);
}

.gauge--regression .gauge-arc__indicator {
  background: var(--regression-color);
}

.gauge--improvement .gauge-arc__delta-wrapper .gauge-arc__arc {
  stroke: var(--improvement-color);
}

.gauge--regression .gauge-arc__delta-wrapper .gauge-arc__arc {
  stroke: var(--regression-color);
}
